/**
 * 🤖 AUTO-GENERATED API SCHEMA FILE - DO NOT EDIT DIRECTLY!
 *
 * This file is automatically generated from entity configuration files.
 * Any manual changes will be lost when the generator runs again.
 *
 * 🔄 DATA FLOW PIPELINE:
 * 1. Entity Config (config/entities/user_mentions-entity-config.ts) → Single Source of Truth
 * 2. THIS FILE → TypeBox schemas for runtime validation + API types
 * 3. API Clients → Use these schemas for request/response validation
 * 4. React Hooks → Use these types for type-safe data fetching
 * 5. Components → Import types from this schema file
 *
 * 🛠️ TO MODIFY:
 * - Edit the entity config file: config/entities/user_mentions-entity-config.ts
 * - Run: npm run schemas:gen (regenerates this file)
 * - Or run: npm run db:full-workflow (does everything)
 *
 * 📋 ARCHITECTURE:
 * - Entity configs define field publicity, types, and validation rules
 * - TypeBox schemas provide runtime validation for API requests/responses
 * - Static types are derived from TypeBox schemas for compile-time safety
 * - Query options and response types standardize API interactions
 *
 * 🔗 RELATED FILES:
 * - config/entities/user_mentions-entity-config.ts (source configuration)
 * - scripts/generate-api-clients.ts (this generator)
 * - client/api/generated_clients/generated-user_mentions-api-client.ts (API client using these schemas)
 * - client/api/generated_hooks/user_mentions.ts (React hooks using these types)
 *
 * 🔒 SECURITY: Only fields marked as 'public: true' in the config are included
 *
 * Generated at: 2026-06-29T23:22:39.747Z
 * Source config: config/entities/user_mentions-entity-config.ts
 * Public fields: 13/13 total fields
 */

import { Type, Static } from '@sinclair/typebox';


// TypeBox schemas for runtime validation (public fields only)
export const UserMentionsSchema = Type.Object({
  id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // id field - primary key
  note_id: Type.String({ format: "uuid" }), // note_id field
  user_profile_id: Type.String({ format: "uuid" }), // user_profile_id field
  mentioned_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // mentioned_at field
  mentioned_by: Type.Union([Type.String(), Type.Null()]), // mentioned_by field
  mention_type: Type.Union([Type.String(), Type.Null()]), // mention_type field
  is_read: Type.Union([Type.Boolean(), Type.Null()]), // is_read field
  read_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // read_at field
  trig_user_full_name: Type.Union([Type.String(), Type.Null()]), // trig_user_full_name field - trigger-populated denormalized field
  trig_user_email: Type.Union([Type.String(), Type.Null()]), // trig_user_email field - trigger-populated denormalized field
  trig_user_phone_number: Type.Union([Type.String(), Type.Null()]), // trig_user_phone_number field - trigger-populated denormalized field
  trig_note_content: Type.Union([Type.String(), Type.Null()]), // trig_note_content field - trigger-populated denormalized field
  trig_note_title: Type.Union([Type.String(), Type.Null()]), // trig_note_title field - trigger-populated denormalized field
});

export const CreateUserMentionsSchema = Type.Object({
  note_id: Type.String({ format: "uuid" }), // note_id field
  user_profile_id: Type.String({ format: "uuid" }), // user_profile_id field
  mentioned_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // mentioned_at field
  mentioned_by: Type.Union([Type.String(), Type.Null()]), // mentioned_by field
  mention_type: Type.Union([Type.String(), Type.Null()]), // mention_type field
  is_read: Type.Union([Type.Boolean(), Type.Null()]), // is_read field
  read_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // read_at field
});

export const UpdateUserMentionsSchema = Type.Object({
  note_id: Type.String({ format: "uuid" }), // note_id field
  user_profile_id: Type.String({ format: "uuid" }), // user_profile_id field
  mentioned_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // mentioned_at field
  mentioned_by: Type.Union([Type.String(), Type.Null()]), // mentioned_by field
  mention_type: Type.Union([Type.String(), Type.Null()]), // mention_type field
  is_read: Type.Union([Type.Boolean(), Type.Null()]), // is_read field
  read_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // read_at field
});

// TypeScript types derived from TypeBox schemas (matching server-side pattern)
export type UserMentionsRow = Static<typeof UserMentionsSchema>;
export type UserMentionsInsert = Static<typeof CreateUserMentionsSchema>;
export type UserMentionsUpdate = Static<typeof UpdateUserMentionsSchema>;

// Legacy type aliases for backward compatibility
export type UserMentions = UserMentionsRow;
export type CreateUserMentions = UserMentionsInsert;
export type UpdateUserMentions = Static<typeof UpdateUserMentionsSchema>;

// Field configuration metadata
export const UserMentionsFieldConfig = {
  filterable: ['id', 'note_id', 'user_profile_id', 'is_read'] as const,
  sortable: [] as const,
  searchable: [] as const,
  required: ['note_id', 'user_profile_id'] as const,
  readonly: ['id', 'trig_user_full_name', 'trig_user_email', 'trig_user_phone_number', 'trig_note_content', 'trig_note_title'] as const,
} as const;

// Query options interface for API operations
import type { UnifiedQueryOptions } from '../../../config/search/global-search-config.js';

export interface UserMentionsQueryOptions extends UnifiedQueryOptions {}

// Response types for API operations
export interface UserMentionsResponse {
  data: UserMentions[] | null;
  error: Error | null;
  count?: number;
}

export interface SingleUserMentionsResponse {
  data: UserMentions | null;
  error: Error | null;
}
